module.exports = "img/info-slide-3.3d4d47.jpeg";